(function() {
    "use strict";

    var module = angular.module("app");

    module.config(
    [
        "$provide", "$httpProvider",
        function($provide, $httpProvider) {

            $provide.factory("authTokenHttpInterceptor",
            [
                "$q", "authenticationTokenService",
                function($q, authenticationTokenService) {
                    return {
                        request: function(request) {
                            var authToken = authenticationTokenService.getAuthToken();
                            if (authToken) {
                                request.headers["Authorization"] = authToken;
                            }

                            return request;
                        }
                    };
                }
            ]);

            $httpProvider.interceptors.push("authTokenHttpInterceptor");
        }
    ]);
}());